import { Check, ArrowRight } from "lucide-react";
import { SOLUTIONS_TIERS } from "../../data/content";

const FEATURES = {
  retro: ["No rewiring", "App + voice control", "Works behind existing switches", "Installed in 1 day"],
  "smart-touch": ["Glass touch panels", "Personalized scenes", "Curtain & AC control", "5-year warranty"],
  knx: ["International KNX standard", "Wired, decentralised, reliable", "Used in palaces & yachts", "Engineered for villas"],
};

export default function SolutionsTiers({ onBook }) {
  return (
    <section
      data-testid="solutions-tiers"
      className="relative bg-[var(--gx-black)] py-24 lg:py-40 border-t border-line/60 grain"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="max-w-[820px] mb-16 lg:mb-24">
          <p className="eyebrow mb-5">Three Paths. One Standard.</p>
          <h2 className="h1-display text-white">
            How would you like to begin?
          </h2>
          <p className="lead mt-7 max-w-[54ch]">
            Whether you live in your home today, are designing one for tomorrow, or building a luxury villa —
            GenieX has a path that suits you. All in transparent ₹ pricing.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-7">
          {SOLUTIONS_TIERS.map((t) => (
            <article
              key={t.key}
              data-testid={`tier-${t.key}`}
              className={`card-lux relative p-7 lg:p-9 flex flex-col ${
                t.featured ? "lg:scale-[1.04] lg:-translate-y-2 border-gold/40 shadow-[0_24px_60px_-20px_rgba(201,169,97,0.25)]" : ""
              }`}
            >
              <div
                className={`absolute inset-0 rounded-[18px] bg-gradient-to-b ${t.color} pointer-events-none`}
              />
              <div className="relative">
                {t.featured && (
                  <span className="absolute -top-1 right-0 text-[10px] tracking-[0.28em] uppercase text-gold">
                    Most Chosen
                  </span>
                )}
                <p className="text-[11px] tracking-[0.28em] uppercase text-mute">{t.badge}</p>
                <h3 className="font-display text-3xl lg:text-4xl text-white mt-3 tracking-tight">
                  {t.title}
                </h3>
                <p className="text-[14px] text-dim mt-2">{t.sub}</p>
                <p className="mt-7 font-display text-2xl text-gold">{t.price}</p>
                <p className="text-[14px] text-dim leading-relaxed mt-5 max-w-[36ch]">{t.body}</p>

                <ul className="mt-7 space-y-3">
                  {FEATURES[t.key].map((f) => (
                    <li key={f} className="flex items-start gap-3 text-[13.5px] text-white/90">
                      <Check className="w-4 h-4 text-gold mt-0.5 shrink-0" /> {f}
                    </li>
                  ))}
                </ul>

                <button
                  onClick={onBook}
                  data-testid={`tier-cta-${t.key}`}
                  className={`mt-10 w-full ${t.featured ? "btn-gold" : "btn-outline"}`}
                >
                  Book Consultation <ArrowRight className="w-3.5 h-3.5" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
